import React from 'react';
import styled from 'styled-components'
import Select from 'react-select';
import taxiIco from './../../../img/taxiW.png'
import conductor from './../../../img/conductor.svg'
import vehiculo from './../../../img/vehiculo.svg'


const ModalAsignar = (props) => {
    const guardar= ()=>{
        props.guardar(props.viaje);

        if(props.conductorSeleccionado && props.conductorSeleccionado.value && props.vehiculoSeleccionado && props.vehiculoSeleccionado.value)
            props.close(false);
    }

    return (
    <Wrapper >
        <div className='modalAsignar'>
            <header>
                <div>
                    <img src={taxiIco} style={{ display:'inline-block' }} />
                    <h3 className='title-blue' style={{ display:'inline-block' }} >Asignación de Conductores / Vehiculos</h3>
                </div>
                <div className='text-info' >para el viaje</div>
                <div className='text-info' ><strong>{props.viaje.nombProgra}</strong></div>
            </header>
            <h4>Por favor, seleccione el conductor y el vehículo</h4>
            <div className='contenido'>
                <div>
                    <h5> <img src={conductor}/> Conductor</h5>
                    <Select 
                        value={props.conductorSeleccionado}
                        className="css-10nd86i-2" placeholder='Seleccione...' 
                        onChange={(event) => props.addCond(event, 0)} 
                        options={props.conductores} 
                    />
                </div>
                <div>
                    <h5> <img src={vehiculo} /> Vehículo</h5>
                    <Select 
                        value={props.vehiculoSeleccionado}
                        className="css-10nd86i-2" placeholder='Seleccione...' 
                        onChange={(event) => props.addCar(event, props.viaje, 0)} 
                        options={props.vehiculos} 
                    />
                </div>
            </div>
            <footer>
                <button 
                    onClick={()=>props.close(false)}
                    className="btn btn-secondary">
                    Cancelar</button>
                
                {
                    props.isAsignado !== 'No Asignado' ?
                    <button 
                        onClick={guardar}
                        className='btn btn-small-orange'>
                        Reasignar</button>
                    :<button 
                        onClick={guardar}
                        className='btn btn-small-green'>
                        Confirmar</button>
                }
            </footer>
        </div>
        <div className='background' onClick={()=>props.close(false)} /> 
    </Wrapper>
    )
}


const Wrapper = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    position: fixed;
    background: rgba(0,0,0,0.2);
    width:100vw;
    height:100vh;
    top:0;
    left: 0;
    z-index: 25;

    .modalAsignar{
        background: white;
        width:60vw;
        /* min-width: 789px; */
        /* height:60vh; */
        /* min-height: 476px; */
        border-radius: 10px;
        border: 1px solid #C4C4C4;
        z-index:26;
    }

    .background{
        position:absolute;
        width:100%;
        height:100%;
    }

    header {
        margin-top: 2em;

        div:first-child{
            display: flex;
            justify-content:center;
            align-items:flex-end;
            margin-bottom:0.5em;
    
            img {
                margin-right:1em;
            }
        }

        .text-info {
            text-align:center;
        }
    }

    h4 {
        text-align:center;
        margin:2em 0;
    }

    .contenido{
        display:flex;
        justify-content: space-evenly;
        flex-wrap:wrap;

        .css-10nd86i-2 {
            margin-top:1em;
            min-width:15em;
        }
    }

    footer {
        display:flex;
        justify-content: center;
        margin:4em 0 2em;

        button {
            margin:0.5em;

        }
    }
`

export default ModalAsignar;


// WEBPACK FOOTER //
// ./src/Components/Rutas/Components/ModalAsignar.js